module.exports = __webpack_public_path__ + "assets/rating-man.88ebaf93.svg";